const WASM_BASE =
  (process.env.VITE_GENIUS_WASM_BASE ?? '/wasm/genius').replace(/\/$/, '');

type GeniusAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface GeniusCryptoGlobal {
  __geniusAesGcmDecrypt?: GeniusAesGcmDecryptFn;
}

function geniusCryptoGlobal(): GeniusCryptoGlobal {
  return globalThis as GeniusCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureGeniusCryptoHelper(): Promise<void> {
  const g = geniusCryptoGlobal();
  if (cryptoHelperLoaded && g.__geniusAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/genius-crypto.js`);
  if (!geniusCryptoGlobal().__geniusAesGcmDecrypt) {
    throw new Error('Genius crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

/** Decrypt server bootstrap cipher via Web Crypto (AES-GCM). Returns base64 plaintext for WASM. */
export async function decryptGeniusBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureGeniusCryptoHelper();
  const decrypt = geniusCryptoGlobal().__geniusAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('Genius crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
